export default function prepareErrors(xhr) {
    let errors = [];
    // возможно, 409 ошибку стоит обработать тут

    if (xhr.status === 401) {
        window.location.reload(true);
        return errors;
    }

    if ([500, 502].includes(xhr.status)) {
        errors = ['server_error'];
        return errors;
    }

    let errorData;

    try {
        errorData = JSON.parse(xhr.responseText);
    } catch (err) {
        errorData = {};
    }

    if (errorData.errors) {
        if (errorData.extras) {
            if (errorData.extras.reload) {
                window.location.reload(true);
            } else if (errorData.extras.banned_until) {
                errors = Object.entries(errorData.errors).map(
                    error => `${error[0]}:${error[1][0]}`,
                );
            } else {
                errors = Object.values(errorData.errors).map(error => {
                    const extra = Object.values(errorData.extras)[0];

                    return `${extra}:${error[0]}`;
                });
            }
        } else {
            errors = Object.entries(errorData.errors).map(error => `${error[0]}:${error[1][0]}`);
        }
    } else if (errorData.errors_codes) {
        errors = Object.entries(errorData.errors_codes).map(
            ([key, value]) => `${key}:${value[0]}`
        );
    }

    return errors;
}
